export default({
    set_for_routes_count(state,count){
        state.documentForRoutesCount = count
    },
    set_routes_in_progress_count(state,count){
        state.routesInProgressCount = count
    },
})